const PLATFORM_APP_HOST = (process.env.REACT_APP_PLATFORM_APP_HOST || "buildhof.com")
  .trim()
  .toLowerCase()
  .replace(/^https?:\/\//, "")
  .replace(/\/$/, "");

export function DomainNotConnected() {
  return (
    <main
      className="page-shell flex min-h-screen items-center justify-center bg-[#F7F4EF] px-4 py-16 text-[#173B2F]"
      data-testid="domain-not-connected-page"
    >
      <div className="max-w-md text-center">
        <h1 className="text-3xl font-extrabold" data-testid="domain-not-connected-title">
          Domain not connected
        </h1>
        <p className="mt-3 text-sm leading-6 text-[#4a493f]" data-testid="domain-not-connected-body">
          This domain is not linked to a BuildHof storefront yet. If you own this domain, open your
          BuildHof dashboard, save the domain, and complete DNS verification.
        </p>
        <a
          href={`https://${PLATFORM_APP_HOST}`}
          className="mt-6 inline-block text-sm font-bold text-[#EA6A3B] hover:underline"
          data-testid="domain-not-connected-home-link"
        >
          Go to BuildHof
        </a>
      </div>
    </main>
  );
}
